import {UserApi} from "~/gen/openapi/portalService";
import {useQuery} from "@tanstack/vue-query";

export const useUserService = () => {
    const {$axios, $config} = useNuxtApp()
    const userApi = new UserApi(undefined, $config.public.apiBaseHost, $axios)

    const loggedInUserQuery = () => useQuery({
        queryKey: ['userGetLoggedInUser'],
        queryFn: async () => {
            return (await userApi.userGetLoggedInUser()).data
        },
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false
    })

    return {
        loggedInUserQuery
    }
}